import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDraftOrderPlatformDiscountAllocationKey,
  ShopifyDraftOrderPlatformDiscountAllocationToShopKey,
  ShopifyDraftOrderPlatformDiscountKey,
  ShopifyDraftOrderPlatformDiscountToDraftOrderPlatformDiscountAllocationKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import { ConnectionModelSpecVersion, buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDraftOrderPlatformDiscountAllocationKey,
  "2024-07": {
    name: "Shopify Draft Order Platform Discount Allocation",
    fields: [
      {
        name: "ID",
        fieldType: FieldType.ID,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "id" } },
      },
      {
        name: "Draft Order Platform Discount",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDraftOrderPlatformDiscountToDraftOrderPlatformDiscountAllocationKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "draftOrder",
            skipGraphQLSelection: true,
          },
        },
        configuration: {
          relatedModelKey: ShopifyDraftOrderPlatformDiscountKey,
        },
      },
      {
        name: "Quantity",
        fieldType: FieldType.Number,
        contributorConfiguration: { [ShopifyDominion.id]: { graphQLFieldKey: "quantity" } },
      },
      {
        name: "Reduction Amount",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "reductionAmount",
          },
        },
      },
      {
        name: "Reduction Amount Set",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "reductionAmountSet",
          },
        },
      },
      {
        name: "Target",
        fieldType: FieldType.JSON,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "target",
          },
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDraftOrderPlatformDiscountAllocationToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifyDraftOrderPlatformDiscount
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDraftOrderPlatformDiscountAllocation = ({
  apiVersion,
  frameworkVersionConstraint,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint);
